<template>
  <div class="md-card-content">
    <div class="md-layout">
      <div class="md-layout-item md-size-30 md-small-size-100 ml-15">
        <label>نوع التقرير</label>
        <model-list-select
          class="input-must-rtl"
          :list="reportList"
          v-model="currentSt"
          option-value="id"
          option-text="name"
          @input="$emit('changeReport', $event)"
        />
      </div>

      <div
        class="md-layout-item md-layout-item-time md-size-30 md-small-size-100 ml-15"
        style="position: relative"
      >
        <h4 class="monthly-picker-head" :class="{ active: monthDate }">
          شهر العمل الإضافي
        </h4>
        <vue-monthly-picker
          class="monthly-picker"
          alignment="right"
          v-model="monthDate"
        />
      </div>

      <div
        class="md-layout-item md-size-30 md-small-size-100 ml-15 clear-relative"
      >
        <label>الموظف</label>
        <model-list-select
          class="input-must-rtl"
          :list="employees"
          v-model="employeeId"
          option-value="key"
          option-text="value"
          placeholder="كل الموظفين"
        />
        <ClearButton
          class="absolute-clear-button"
          @click.native="employeeId = null"
        />
      </div>

      <div class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25">
        <label>مصدر البيانات *</label>
        <model-list-select
          class="input-must-rtl"
          :list="dataSourceList"
          v-model="dataSource"
          option-value="id"
          option-text="name"
          placeholder="اختر مصدر البيانات"
        />
      </div>

      <div
        class="md-layout-item md-size-100 mt-25 mtb-25"
        style="text-align: center"
      >
        <md-button
          class="md-success btn_nanosoft"
          :disabled="loadingSearch"
          @click="search"
        >
          <span class="ml-15">بحث</span>
          <md-progress-spinner
            v-if="loadingSearch"
            class="md-accent"
            :md-diameter="15"
            :md-stroke="2"
            md-mode="indeterminate"
          />
        </md-button>

        <md-button
          class="md-info btn_nanosoft"
          :disabled="loadingPdf"
          @click="printPdf"
        >
          <span class="ml-15">طباعة PDF</span>
          <md-progress-spinner
            v-if="loadingPdf"
            class="md-accent"
            :md-diameter="15"
            :md-stroke="2"
            md-mode="indeterminate"
          />
        </md-button>

        <md-button
          class="md-info btn_nanosoft"
          :disabled="loadingExcel"
          @click="printExcel"
        >
          <span class="ml-15">طباعة Excel</span>
          <md-progress-spinner
            v-if="loadingExcel"
            class="md-accent"
            :md-diameter="15"
            :md-stroke="2"
            md-mode="indeterminate"
          />
        </md-button>
      </div>
    </div>

    <div class="md-layout">
      <div class="md-layout-item">
        <md-card-content>
          <md-table
            dir="rtl"
            class="report paginated-table table-striped table-hover mt-25"
          >
            <md-table-row>
              <md-table-cell>ر.م</md-table-cell>
              <md-table-cell>اسم الموظف</md-table-cell>
              <md-table-cell>مدة العمل الإضافي</md-table-cell>
              <md-table-cell>قيمة العمل الإضافي</md-table-cell>
            </md-table-row>

            <md-table-row v-for="(item, i) in allData" :key="i">
              <md-table-cell md-label="ر.م">{{ item.num }}</md-table-cell>
              <md-table-cell md-label="اسم الموظف">{{
                item.employeeName
              }}</md-table-cell>
              <md-table-cell md-label="مدة العمل الإضافي">{{
                item.overTimeHoursDisplay
              }}</md-table-cell>
              <md-table-cell md-label="قيمة العمل الإضافي">{{
                formatValue(item.overTimeValue)
              }}</md-table-cell>
            </md-table-row>

            <md-table-row v-if="allData.length" class="total-row">
              <md-table-cell md-label="ر.م">المجموع</md-table-cell>
              <md-table-cell md-label="اسم الموظف"></md-table-cell>
              <md-table-cell md-label="مدة العمل الإضافي">{{
                totalOverTimeHoursDisplay
              }}</md-table-cell>
              <md-table-cell md-label="قيمة العمل الإضافي">{{
                formatValue(totalOverTimeValue)
              }}</md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>
      </div>
    </div>
  </div>
</template>

<script>
import { ModelListSelect } from "vue-search-select";
import Swal from "sweetalert2";

export default {
  components: { ModelListSelect },

  props: {
    reportList: { type: Array, default: () => [] },
    employees: { type: Array, default: () => [] },
  },

  data() {
    return {
      currentSt: "21",
      monthDate: null,
      employeeId: null,
      dataSource: null,
      dataSourceList: [
        { id: 2, name: "بيانات العمل الإضافي" },
        { id: 1, name: "بيانات المرتب" },
      ],
      allData: [],
      totalOverTimeValue: 0,
      totalOverTimeHoursDisplay: "",
      loadingSearch: false,
      loadingPdf: false,
      loadingExcel: false,
    };
  },

  methods: {
    convertMonth(val) {
      if (!val) return null;
      try {
        const d = new Date(val);
        if (isNaN(d.getFullYear())) return null;
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, "0");
        return `${year}-${month}-01`;
      } catch (e) {
        return null;
      }
    },

    validateMonth() {
      const m = this.convertMonth(this.monthDate);
      if (!m) {
        Swal.fire({
          title: "الشهر مطلوب",
          text: "يرجى اختيار شهر العمل الإضافي أولاً",
          icon: "warning",
          confirmButtonText: "حسناً",
        });
      }
      return m;
    },

    validateDataSource() {
      if (!this.dataSource) {
        Swal.fire({
          title: "مصدر البيانات مطلوب",
          text: "يرجى اختيار مصدر البيانات أولاً",
          icon: "warning",
          confirmButtonText: "حسناً",
        });
        return false;
      }
      return true;
    },

    formatValue(val) {
      if (val == null) return "";
      return Number(val).toLocaleString();
    },

    buildParams(monthDate) {
      const params = { MonthDate: monthDate };
      if (this.employeeId) params.EmployeeId = this.employeeId;
      if (this.dataSource) params.DataSource = this.dataSource;
      return params;
    },

    downloadBlob(blob, filename) {
      const href = URL.createObjectURL(blob);
      const a = Object.assign(document.createElement("a"), {
        href,
        style: "display:none",
        download: filename,
      });
      document.body.appendChild(a);
      a.click();
      URL.revokeObjectURL(href);
      a.remove();
    },

    async search() {
      const monthDate = this.validateMonth();
      if (!monthDate) return;
      if (!this.validateDataSource()) return;
      try {
        this.loadingSearch = true;
        const { data } = await this.$axios.get(
          "/api/SalariesReports/OverTimeReport",
          {
            params: this.buildParams(monthDate),
          }
        );
        const items = (data.data && data.data.items) || [];
        this.allData = items.map((item, i) => ({ ...item, num: i + 1 }));
        this.totalOverTimeValue =
          (data.data && data.data.totalOverTimeValue) || 0;
        this.totalOverTimeHoursDisplay =
          (data.data && data.data.totalOverTimeHoursDisplay) || "";
      } catch (e) {
        // silent
      } finally {
        this.loadingSearch = false;
      }
    },

    async printPdf() {
      const monthDate = this.validateMonth();
      if (!monthDate) return;
      if (!this.validateDataSource()) return;
      try {
        this.loadingPdf = true;
        const { data } = await this.$axios.get(
          "/api/SalariesReports/OverTimeReportFile",
          {
            params: { ...this.buildParams(monthDate), reportType: "pdf" },
            responseType: "blob",
          }
        );
        this.downloadBlob(
          new Blob([data], { type: "application/pdf" }),
          "تقرير العمل الإضافي.pdf"
        );
      } catch (e) {
        // silent
      } finally {
        this.loadingPdf = false;
      }
    },

    async printExcel() {
      const monthDate = this.validateMonth();
      if (!monthDate) return;
      if (!this.validateDataSource()) return;
      try {
        this.loadingExcel = true;
        const { data } = await this.$axios.get(
          "/api/SalariesReports/OverTimeReportFile",
          {
            params: { ...this.buildParams(monthDate), reportType: "excel" },
            responseType: "blob",
          }
        );
        this.downloadBlob(
          new Blob([data], {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          }),
          "تقرير العمل الإضافي.xlsx"
        );
      } catch (e) {
        // silent
      } finally {
        this.loadingExcel = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .total-row {
  font-weight: 700;
  background-color: #f5f5f5;
}
</style>
